import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import TravelPlanAddButton from '../TravelPlanAddButton.vue'
import { DateRange, Waypoint } from '@/types/trip'
import { getDateFromLambusDate } from '@/utils/date-utils'

export interface WaypointHoverAddButtonProps {
  previousWaypoint?: Waypoint
  waypoint: Waypoint
  isFirstWaypoint: boolean
  showHoverButtons?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WaypointHoverAddButtons',
  props: {
    previousWaypoint: null,
    waypoint: null,
    isFirstWaypoint: { type: Boolean },
    showHoverButtons: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  previousWaypoint?: Waypoint
  waypoint: Waypoint
  isFirstWaypoint: boolean
  showHoverButtons?: boolean
};



const indexOffset = computed(() => {
  return props.isFirstWaypoint
    ? props.waypoint.transportations.filter((t) => t.isArrivalTransportation)
        .length
    : undefined
})

function getPeriodFromDateRange(
  dateRange?: DateRange,
  dayOfMonth?: 'first' | 'last',
) {
  if (!dateRange) {
    return undefined
  }

  return {
    start: getDateFromLambusDate(dateRange, dayOfMonth),
    end: getDateFromLambusDate(dateRange, dayOfMonth),
  }
}

return { __sfc: true,props, indexOffset, getPeriodFromDateRange, TravelPlanAddButton }
}

})